import { useEffect, useState } from 'react'
import { values } from 'lodash'

import { auth, db } from '../firebase'
import { off, ref, query, orderByChild, limitToFirst, onValue } from 'firebase/database'

const useScoreHistory = () => {
  const [scoreHistory, setScoreHistory] = useState([])
  const userId = auth.currentUser.uid
  const dbHistoryRef = ref(db, `userActivity/${userId}/scoreHistory`)

  useEffect(() => {
    onValue(query(dbHistoryRef, orderByChild('timestamp'), limitToFirst(100)), (historySnap) => {
      if (historySnap.val() !== null) {
        const arr = Array.isArray(historySnap.val()) ? historySnap.val() : values(historySnap.val())
        setScoreHistory(arr
          .reduce((acc, x) => {
            return [x, ...acc]
          }, [])
        )
      }
    })
    return () => off(dbHistoryRef)
  }, [])

  return {
    scoreHistory
  }
}

export default useScoreHistory
